export default "__VITE_ASSET__n_Q10Vn2__"